import { useGQL } from 'services/gql';
import { brandSchema } from './brandSchema';

// eslint-disable-next-line
const getBrand = /* GraphQL */ `
    query getBrand($email: String){
        getBrand(email: $email){
            ${brandSchema}
        }
    }
`;

const getBrandByExternalId = /* GraphQL */ `
    query getUser($id: String, $nextToken: String){
      listBrands(filter: {externalId: {eq: $id}}, nextToken: $nextToken) {
        nextToken
        items {
          ${brandSchema}  
        }
      }
    }
`;

export const useBrandGql = () => {
  const { createMutation, updateMutation, sendQuery } = useGQL('brand');

  //QUERY
  const get = async (externalId, limitless) => {
    const listResult = await sendQuery(
      'get-by-external-id',
      getBrandByExternalId,
      {
        id: externalId,
      },
      limitless
    );
    if (listResult?.items) {
      return listResult.items[0];
    } else {
      return null;
    }
  };

  //MUTATION
  const create = (input) => createMutation(input);
  const update = (input) => updateMutation(input);

  return {
    get,
    create,
    update,
  };
};

export default useBrandGql;
